<script setup lang="ts">
import { ref } from 'vue'
import { getLocale, setLocale } from '@app/i18n'

const current = ref(getLocale())

const options: { value: 'zh-CN' | 'en-US'; label: string }[] = [
  { value: 'zh-CN', label: '中文' },
  { value: 'en-US', label: 'English' }
]

function change(locale: 'zh-CN' | 'en-US') {
  current.value = locale
  setLocale(locale)
}
</script>

<template>
  <div class="flex items-center gap-sm">
    <span class="text-text-secondary text-sm">语言</span>
    <div class="flex rounded-md border border-border-subtle overflow-hidden">
      <button
        v-for="opt in options"
        :key="opt.value"
        class="px-sm py-xs text-sm transition-colors"
        :class="current === opt.value
          ? 'bg-brand-primary text-white'
          : 'bg-background-primary text-text-secondary hover:bg-background-secondary'"
        @click="change(opt.value)"
      >
        {{ opt.label }}
      </button>
    </div>
  </div>
</template>
